/** Resolve the approved public address before requesting any host catalog.
 * Availability still coalesces identical requests in availability-cache.ts. */
export function initialProfileResponse(
  _request: Request,
): Promise<Response> | undefined {
  return undefined;
}
